"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyPressListener = void 0;
var react_1 = require("react");
var KeyPressListener = function (_a) {
    var code = _a.code, handler = _a.handler, _b = _a.keyEvent, keyEvent = _b === void 0 ? 'keyup' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var handleKeyEvent = function (event) {
        if (disabled) {
            event.preventDefault();
            return;
        }
        if (event.code === code) {
            handler(event);
        }
    };
    react_1.useEffect(function () {
        document.addEventListener(keyEvent, handleKeyEvent);
        return function () {
            document.removeEventListener(keyEvent, handleKeyEvent);
        };
    });
    return null;
};
exports.KeyPressListener = KeyPressListener;
//# sourceMappingURL=KeyPressListener.js.map